import { render, staticRenderFns } from "./LossModal.vue?vue&type=template&id=56c9f2f2&scoped=true&"
import script from "./LossModal.vue?vue&type=script&lang=js&"
export * from "./LossModal.vue?vue&type=script&lang=js&"
import style0 from "./LossModal.vue?vue&type=style&index=0&id=56c9f2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9f2f2",
  null
  
)

export default component.exports